module.exports = __webpack_public_path__ + "img/img_fabu.4ca87b2d.png";